import React,{useState,useEffect,useRef} from 'react'
import '../contabildade.css'
import axios from 'axios';
import DatePicker from 'react-date-picker';
import ReactToPrint from 'react-to-print';
import {ComponentToPrint} from './Print';
import { ar } from 'date-fns/locale';
import ReactToExcel from 'react-html-table-to-excel';   
function Rtotal() {
    const[error,setError]=useState();
    const printRelaResumos=useRef();
    const [valori,onChange]=useState(new Date());
    const [valorf,onChangef]=useState(new Date());
    const [aray,setAr]=useState(null);
    const [lisa,setLisa]=useState(null);
    const [cliente,setClientes]=useState();
    const [dados,setDados]=useState("");
    const [Data,setData]=useState("");
    const [dado,setDado]=useState("");
    useEffect(()=>{
        axios({
            method:"post",
            url:`${localStorage.getItem('url')}/web/dailydata/`,
            headers:{'Authorization':`token ${localStorage.getItem('token')}`,'Content-Type':'application/json' },
            data:{id:"sds"}
        }).then(dat=>{ if(dat.status!==200){
            throw Error('Dados de acesso invalidos');  
                }
            return dat
         } ).then( df=>{
             console.log(df.data);
             setAr(df.data);
          }
       
           ).catch(e=>{
            setError(e.message );
        })
    
    },[])
    
    const Send=()=>{

    }
    const FilterData=(row)=>{
        return row.filter((row)=>
         valori.getTime()<=(new Date(row.data_de_compra)).getTime() && (new Date(row.data_de_compra)).getTime() <=valorf.getTime())
     
     }
     const SomaIva=(row)=>{
         let soma=0;
         for(let i=0;i<row.length;i++){
             soma=soma+parseFloat(row[i].iva)
         }
         soma=soma.toFixed(2)
         return soma
     }
     
     const SomaY=(row)=>{
         let soma=0;
         soma=row.toFixed(2)
         return soma
     }
     const SearchD=(row)=>{
       
        return row.filter((row)=>
        
        row.nome.toLowerCase().indexOf(dados)>-1)
    }
    const SearchMeter=(row)=>{
       
        return row.filter((row)=>
        row.numero_do_contador.toLowerCase().indexOf(dado)>-1)
    }
    
     const SomaTSC=(row)=>{
         let soma=0;
         for(let i=0;i<row.length;i++){
             soma=soma+parseFloat(row[i].tsc)
         }
         soma=soma.toFixed(2)
         return soma
         
     }
     const SomaVal=(row)=>{
         let soma=0;
         for(let i=0;i<row.length;i++){
             soma=soma+parseFloat(row[i].valor_pago)
         }
         soma=soma.toFixed(2)
         return soma
         
     }
    const SomaMetros=(row)=>{
        let soma=0;
        for(let i=0;i<row.length;i++){
            soma=soma+parseFloat(row[i].metroscubicos)
        }
        soma=soma.toFixed(2)
        return soma
        
    }
    const Search=(row)=>{
       
        return row.filter((row)=>
        row.metodo.toLowerCase().indexOf(Data)>-1)
    }
  return (
    <div className='Contabilidade'>
       {aray &&   <div className='Totais'>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/vat (1).png')} /></div>
                        <div id="txts">IVA:</div>
                        <div id='valor'>{SomaIva(FilterData(aray))}Mzn</div>
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas-pump.png')} /></div>
                        <div id="txts">TSC:</div>
                        <div id='valor'>{SomaTSC(FilterData(aray))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/flame.png')} /></div>
                        <div id="txts"> Total Liquido:</div>
                        <div id='valor'>{SomaVal(FilterData(aray))-SomaIva(FilterData(aray))-SomaTSC(FilterData(aray))}Mzn</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/gas.png')} /></div>
                        <div id="txts">Total Gas:</div>
                        <div id='valor'>{SomaMetros(FilterData(aray))} m3</div>
                        
                    </div>
                    <div className='info'>
                        <div id="icon_vendas"><img  id="imagem_vendas"src={require('./images/tax.png')} /></div>
                        <div id="txts">Total Bruto:</div>
                        <div id='valor'>{SomaVal(FilterData(aray))} Mzn</div>
                        
                    </div>
                   
      
            </div>} 
            {aray &&  <div className='filters'>
      
      <img  id="imagem_vendas"src={require('./images/clock.png')}  />
            
                <div>
                Inicio
                <DatePicker onChange={onChange} value={valori}/>
                </div>
                
                <img  id="imagem_vendas"src={require('./images/clock.png')}  />
            
                <div>
                Fim
                <DatePicker onChange={onChangef} value={valorf} maxDate={new Date()}/>
                </div>
                <img  id="imagem_vendas"src={require('./images/debt.png')}  />
            
                <div>Metodo de Pagamento<select id="combo" onChange={(e)=>{
                               setData(e.target.value);
                            }}>
             
                            
                                <option value="">NENHUM</option>
                                <option value="m-pesa">Revendedor</option>
                                <option value="m-pesa">M-PESA</option>
                                <option value="E-MOLA">E-MOLA</option>
                                <option value="RECARGAAKI">RECARGAAKI</option>
                                <option value="CONTA MOVEL">CONTA MOVEL</option>
                                <option value="OPERADOR">Visa</option>
                                <option value="OPERADOR">M-KeSH</option>
                                
                            </select>
               </div>
               <img  id="imagem_vendas"src={require('./images/map.png')}  />
                   
               <div>Zona<select id="combo" onChange={(e)=>{
                                const provincia=e.target.value;
                            }}>
             
                            
                                <option value="">NENHUM</option>
                                <option value="m-pesa">Aeroporto</option>
                                
                            </select>
               </div>
               
               
                <img  id="imagem_vendas"src={require('./images/printer.png')}  />
                   
                   <ReactToPrint
                           trigger={() => {
                              return <a  href="#">   
                              <button  id="opcao" value="Nao" onClick={Send} >Imprimir
                              </button>
                  </a>;
                           }}
                           content={() => printRelaResumos.current}
                         />
                      <img  id="imagem"src={require('./images/excel.png')}  />
                     <ReactToExcel 
                    id='opcao'
                    table='contabilidade'
                    filename='Lista_de_clientes'
                    sheet='sheet 1'
                    buttonText='Exportar'/>

                     
                     </div>
                     
                     
                     }
        <div className='TabelaCont'>
                    
            <table id="contabilidade">
            <thead>
            <tr>
            <th>MPS Id</th>
            <th>data</th>
            <th>ID.Cliente</th>
            <th>ID.Contador</th>
            <th>ID.Token</th>
            <th>Canal de Venda</th>
            <th>Iva</th>
            <th>TSC</th>
            <th>m3</th>
            <th>Valor Liquido</th>
            <th>Valor Bruto</th>
            <th>Primavera ID</th>
            </tr>
            </thead>
    
     
         {aray && <tbody>{FilterData(Search(aray)).map((val,key)=>
            {
            return  <tr> 
            <td>{val.id}</td>
            <td>{val.data_de_compra}</td>
            <td>{val.idCliente}</td>
            <td>{val.idContador}</td>
            <td>{val.idToken}</td>
            <td>{val.metodo}</td>
            <td>{val.iva}</td>
            <td>{val.tsc}</td>
            <td>{(parseFloat(val.metroscubicos)).toFixed(2)}</td>
            
            <td>{(parseFloat(val.valor_pago)-parseFloat(val.iva)-parseFloat(val.tsc)).toFixed(2)}</td>
            <td>{val.valor_pago}</td>
            <td>{val.primavera}</td>
            </tr>
            
            }
            )}</tbody>}
    
            </table>
          
            
            

        </div>
        <ComponentToPrint ref={printRelaResumos}>
        <div className='Relatorios'>
            <div className='Sistema_rel'>
            <div id="icon"><img  id="imagem_vendas"src={require('./images/gears copy.png')}  />
                        </div>
                <div id='texts'>
                    <h3>MOZAMBIQUE PREPAYMENT SYSTEM
               </h3>
               <h4>Tipo de relatorio:<h5>Registro de Vendas</h5>
               </h4>
               <h5></h5>
               </div>
              
            </div>
            {aray &&  <table >
            <thead>
            <tr>
            <th>MPS Id</th>
            <th>data</th>
            <th>ID.Cliente</th>
            <th>ID.Contador</th>
            <th>ID.Token</th>
            <th>Canal de Venda</th>
            <th>Iva</th>
            <th>TSC</th>
            <th>m3</th>
            <th>Valor Liquido</th>
            <th>Valor Bruto</th>
            <th>Primavera ID</th>
            </tr>
            </thead>
    
     
         {aray && <tbody>{FilterData(Search(aray)).map((val,key)=>
            {
            return  <tr> 
            <td>{val.id}</td>
            <td>{val.data_de_compra}</td>
            <td>{val.idCliente}</td>
            <td>{val.idContador}</td>
            <td>{val.idToken}</td>
            <td>{val.metodo}</td>
            <td>{val.iva}</td>
            <td>{val.tsc}</td>
            <td>{(parseFloat(val.metroscubicos)).toFixed(2)}</td>
            
            <td>{(parseFloat(val.valor_pago)-parseFloat(val.iva)-parseFloat(val.tsc)).toFixed(2)}</td>
            <td>{val.valor_pago}</td>
            <td>{val.primavera}</td>
            </tr>
            
            }
            )}</tbody>}
    
            </table>
          }
          
            </div>
        </ComponentToPrint>


    </div>
  )
}

export default Rtotal